import { withDetailView } from '@components/enitity/detail/Detail.view'
import { ChatContent } from '../Chat'
import '../Chat.scss'

export const AdminChat = () => {
  const TableWithView = withDetailView(
    () => (
      <div className="chat-container">
        <ChatContent userSelect />
      </div>
    ),
    'Chat'
  )

  return <TableWithView />
}
